import { render, staticRenderFns } from "./ModalWork.vue?vue&type=template&id=ff043be6&"
import script from "./ModalWork.vue?vue&type=script&lang=js&"
export * from "./ModalWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports